import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box, InputAdornment } from "@mzc-pdc/ui";
import { IconAi, IconAiSearch } from "@mzc-cloudplex/icons";
import TextField from "@components_v2/text-field/text-field";

// keyword 상태는 추천 질문(ai-search-empty)에서도 채우므로 상위(List.js)에서 관리
const AiSearchBar = ({ value = "", onChange, onSubmit, onExit }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ position: "relative", width: "100%", maxWidth: "1280px" }}>
            <TextField
                variant={"outlined"}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onSubmit();
                    }
                }}
                placeholder={t(`common::label::Ask anything`, `Ask anything`)}
                inputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconAiSearch size={20} />
                        </InputAdornment>
                    ),
                }}
                sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "90px",
                        "& fieldset": { borderWidth: "2px", borderColor: "#5f62e5" },
                        "&:hover fieldset": { borderColor: "#5f62e5" },
                        "&.Mui-focused fieldset": { borderColor: "#5f62e5" },
                    },
                }}
            />
        </Box>
    );
};

AiSearchBar.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default AiSearchBar;
